import './NewUserProgramForm.css'
import { Button } from '@mui/material'
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';


export default function NewUserForm({ updateUser, handleCloseNewUserForm }) {
    const [userName, setUserName] = useState('')
    const [email, setEmail] = useState('')

    const [userGroup, setUserGroup] = useState('')
    const filter = createFilterOptions();
    const allUsers = useSelector((state) => state.user.allUsers)
    const companyId = useSelector((state) => state.company.id)

    const userCategories = []
    allUsers && allUsers.map(u => {
        if (!userCategories.find(c => c.userGroup === u.usergroup)) {
            userCategories.push({userGroup: u.usergroup})
        }
        return null
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        var updatedUser = { 
            id: uuid(),
            name: userName,
            email: email,
            usergroup: userGroup.userGroup,
            companyid: companyId
        }
        updateUser(updatedUser)
        handleCloseNewUserForm()

    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%', mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="userName"
                    label="Navn"
                    name="userName"
                    autoComplete="userName"
                    autoFocus
                    value={userName}
                    onChange={(event) => {
                        setUserName(event.target.value);
                    }}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="E-postadresse"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={(event) => {
                        setEmail(event.target.value);
                    }}
                />
                <Autocomplete
                    value={userGroup}
                    onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                            setUserGroup({
                                userGroup: newValue,
                            });
                        } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setUserGroup({
                                userGroup: newValue.inputValue,
                            });
                        } else {
                            setUserGroup(newValue);
                        }
                    }}
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option) => inputValue === option.userGroup);
                        if (inputValue !== '' && !isExisting) {
                            filtered.push({
                                inputValue,
                                userGroup: `Legg til "${inputValue}"`,
                            });
                        }
                        return filtered;
                    }}
                    margin="normal"
                    // size='small'
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="userGroup"
                    options={userCategories}
                    getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        // Regular option
                        return option.userGroup;
                    }}
                    renderOption={(props, option) => <li {...props}>{option.userGroup}</li>}
                    sx={{ width: '100%', mt: 3 }}
                    freeSolo
                    renderInput={(params) => (
                        <TextField {...params} label="Brukergruppe *" />
                    )}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Legg til
                </Button>
            </Box>
        </Box>

    )
}